import { render, staticRenderFns } from "./WidgetOils.vue?vue&type=template&id=5d2f98a9"
import script from "./WidgetOils.vue?vue&type=script&lang=js"
export * from "./WidgetOils.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports